<template>
  <div>
    
    <div style="text-align: center; margin-top: 40px;">
      <h3>Pré-matrícula / Lista de Espera 2026</h3>  
      <!-- <p>
        O agendamento para matrícula na rede municipal de educação está encerrado. <br>
        Mariores informações por meio do whatsapp 7732293378 ou em qualquer escola da rede municipal de ensino.
      </p> -->
      <!-- <p>
        O agendamento online para a terceira fase da matrícula (alunos novos na rede municipal de ensino), 
        estará disponível <br> a partir das 08:00h do dia 21/01/2026 e se encerrará às 23:59h do dia 23/01/2026.<br>        
      </p> -->
    </div>
    <div class="opcoes-menu">   

      <router-link v-if="$store.getters.menuVisivel('lista_espera')" to="lista-espera">
        <div class="op-menu">
          <img src="/public/icon/list.png" />
          <span>Consulte a Lista de Espera</span>
        </div>
      </router-link>

      <router-link v-if="$store.getters.menuVisivel('inscricao')" to="inscricao-novatos">
        <div class="op-menu nova-inscricao">
          <img src="/public/icon/calendario.png" />
          <span> Faça sua Inscrição </span>
        </div>
      </router-link>

      <router-link v-if="$store.getters.menuVisivel('cancelar')" to="cancela-inscricao">
        <div class="op-menu">
          <img src="/public/icon/cancelar.png" />
          <span>Cancelar Inscrição</span>
        </div>
      </router-link>

      <router-link v-if="$store.getters.menuVisivel('consultar')" to="consulta-inscricao">
        <div class="op-menu">
          <img src="/public/icon/consultar.png" />
          <span>Consulte sua Inscrição</span>
        </div>
      </router-link>

      <!-- BLOCO D — itens 63, 64 e 66: fluxo público da lista de espera. -->
      <router-link v-if="$store.getters.menuVisivel('lista_espera_inscricao')" to="lista-espera-inscricao">
        <div class="op-menu nova-inscricao">
          <img src="/public/icon/calendario.png" />
          <span>Inscreva-se na Lista de Espera</span>
        </div>
      </router-link>

      <router-link v-if="$store.getters.menuVisivel('lista_espera_consulta')" to="lista-espera-consulta">
        <div class="op-menu">
          <img src="/public/icon/consultar.png" />
          <span>Consulte sua Posição na Lista</span>
        </div>
      </router-link>

      <router-link v-if="$store.getters.menuVisivel('lista_espera_publica')" to="lista-espera-publica">
        <div class="op-menu">
          <img src="/public/icon/list.png" />
          <span>Lista de Espera — Publicação Oficial</span>
        </div>
      </router-link>

      <router-link v-if="$store.getters.menuVisivel('calendario')" to="calendario">
        <div class="op-menu">
          <img src="/public/icon/calendario.png" />
          <span>Calendário de Matrícula</span>
        </div>
      </router-link>

      <router-link v-if="$store.getters.menuVisivel('contato')" to="contato">
        <div class="op-menu">
          <img src="/public/icon/contato.png" />
          <span>Contato</span>
        </div>
      </router-link>

      <router-link v-if="$store.getters.menuVisivel('faq')" to="faq">
        <div class="op-menu">
          <img src="/public/icon/faq1.png" />
          <span>Perguntas Frequentes</span>
        </div>
      </router-link>
    
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: "",
    };
  },
  mounted() {
    // setInterval(() => {
    //   window.location.reload()
    // }, 30000)
  },
  methods: {
    getAmbiente() { },
  },
  components: {},
};
</script>
